import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Camera, Heart, User } from 'lucide-react';
import { usePWA } from '@/hooks/usePWA';

const MobileNav = ({ isAuthenticated }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isStandalone } = usePWA();

  // Only show in standalone mode or on mobile
  const isMobile = window.innerWidth < 768;
  if (!isMobile && !isStandalone) return null;

  // Don't show on certain pages
  const hiddenPaths = ['/login', '/admin', '/terms', '/privacy', '/cookies', '/policies'];
  if (hiddenPaths.includes(location.pathname) || location.pathname.startsWith('/shared')) {
    return null;
  }

  const navItems = [
    {
      icon: Home,
      label: 'Home',
      path: '/',
      requiresAuth: false
    },
    {
      icon: Camera,
      label: 'Analyze',
      path: '/dashboard',
      requiresAuth: true
    },
    {
      icon: Heart,
      label: 'Palettes',
      path: '/profile?tab=palettes',
      requiresAuth: true
    },
    {
      icon: User,
      label: 'Profile',
      path: '/profile',
      requiresAuth: true
    }
  ];

  const handleNavigation = (item) => {
    if (item.requiresAuth && !isAuthenticated) {
      navigate('/login');
      return;
    }
    
    if (item.path.includes('?')) {
      const [path, query] = item.path.split('?');
      navigate(path + '?' + query);
    } else {
      navigate(item.path);
    }
  };

  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path.split('?')[0]);
  };

  return (
    <nav className="mobile-nav">
      <div className="mobile-nav-inner">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          
          return (
            <button
              key={item.path}
              onClick={() => handleNavigation(item)}
              className={`mobile-nav-item ${active ? 'active' : ''}`}
            >
              <Icon className="mobile-nav-icon" />
              <span className="mobile-nav-label">{item.label}</span>
            </button>
          );
        })}
      </div>
      
      {/* Safe area spacer for notched devices */}
      <div className="mobile-nav-safe-area" />
    </nav>
  );
};

export default MobileNav;
